import { isNil, isString, omitBy, trim } from "lodash";

export default (obj: Record<string, any>): Record<string, any> =>
  omitBy(obj, value => isNil(value) || (isString(value) && trim(value).length === 0));
